import axios from '@/common/axios-utils';

export default {
  // 接口文档：https://km.sankuai.com/page/1308307216
  getAreaList(): any {
    return axios.get('/api/gw/v1/gis/list');
  },
  // 接口文档：https://km.sankuai.com/page/1308307216
  onSave(params: any): any {
    return axios.post('/api/gw/v1/resource/save', params);
  },
};
